import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import CarouselBaseContainer from 'components/carousel/CarouselBaseContainer';

const propTypes = {
  items: PropTypes.array.isRequired,
  assignCarouselRef: PropTypes.func,
};

function CarouselPopularItemsComponent({ items, assignCarouselRef }) {
  return (
    <Container>
      <CarouselBaseContainer
        items={items}
        nSettings={{
          dots: false,
          arrows: false,
          autoplay: false,
          initialSlide: 1,
          slidesToShow: 1,
          centerPadding: '0',
          variableWidth: true,
          swipeToSlide: true,
          rows: 1,
          slidesPerRow: 1,
          pauseOnFocus: true,
          className: 'carousel-recommended-hotels',
        }}
        assignCarouselRef={assignCarouselRef}
      />
    </Container>
  );
}

CarouselPopularItemsComponent.propTypes = propTypes;

export default CarouselPopularItemsComponent;

const Container = styled.div`
  .slick-list:first-child {
    overflow: visible;

    .slick-track:first-child {
      .slick-slide {
        width: 336px;
        display: flex;
        justify-content: center;
        align-items: center;
      }
    }
  }
`;
